import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { UserCinema, UserCinemas } from './user-cinema.interface';
import { UserCinemaService } from './user-cinema.service';
import { Filters } from '@/core/store/filter.interface';
const service = new UserCinemaService();

export interface UserCinemaState {
   userCinemas: UserCinemas;
}

const UserCinemaStore: Module<UserCinemaState, StoreState> = {
   namespaced: true,
   state: {
      userCinemas: {
         series: [],
         movies: [],
      },
   },
   getters: {},
   mutations: {},
   actions: {
      async getAll(context, filters: Filters) {
         if (!this.state.user?.user?.id) return;
         const userCinemas = (await service.getAll(this.state.user.user.id, filters)) || [];
         return userCinemas;
      },
      async get(_context, userCinemaId: number) {
         const userCinema = await service.get(userCinemaId);
         return userCinema;
      },
      async post(_context, userCinema: Partial<UserCinema>) {
         const response = await service.post(userCinema);
         return response;
      },
      async put(
         _context,
         { id, watch_status_id, watched_season_episodes }: { id: number; watch_status_id: number; watched_season_episodes: string },
      ) {
         const response = await service.put(id, watch_status_id, watched_season_episodes);
         return response;
      },
      async delete(_context, id: number) {
         await service.delete(id);
      },
      async getByIds(context, { user_id, cinema_id, type }: { user_id: number; cinema_id: number; type: 'movie' | 'serie' }) {
         const response = await service.getByIds(user_id, cinema_id, type);
         return response;
      },
   },
};

export default UserCinemaStore;
